// @flow
import Partners from 'components/footer/partners/Partners';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';

export default connect((state: StateType) => ({
  partners: state.partnersState.partners
}))(Partners);
